import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { PullFromTable } from "./PullFromTable";
import { PullFromBOMStore, PullFromBOMStoreContext, usePullFromBOMStoreContext } from "./PullFromBOMStore";
import { RestoreSettingsForm } from "../RestoreSettingsForm";
import { Grid } from "designSystem/index";

export const PullFromSourceBOMWizard: FunctionComponent<WizardModalDialogProps<PullFromBOMStore>> = observer((props) => {
	const {
		store,
		...otherProps
	} = props;
	
	const { index } = store || {};

	return (
		<>
			{store && (
				<PullFromBOMStoreContext.Provider value={store}>
					<WizardDialog
						{...otherProps}
						contentPadding={index === 0 ? null : 0}
						// do this to prevent the MUI event from disabling the event of Dojo widget, for example, in the case of Form, when we try to select a value from drop-down, 
						// the focus event from MUI would disable the onMouseUp event of FilteringSelect widget
						disableEnforceFocus
						fullHeight
						pages={[ PullFromTable, RestoreSettingsFormWrapper]}
						store={store}
						supportStepInformation
						width={index === 1 ? 725 : 1200}
					/>
				</PullFromBOMStoreContext.Provider>
			)}
		</>
	);
});

const RestoreSettingsFormWrapper: FunctionComponent = observer(() => {
	const store = usePullFromBOMStoreContext();

	return (
		<RestoreSettingsForm store={store.restoreFromBOMStore} sx={{ p:4 }}  />
	);
});

export default PullFromSourceBOMWizard;